export default {
    IMAGES: 1,
    VIDEOS: 2,
    GIFS: 3
};
